<agr-form-dialog [formGroup]="formGroup" [data]="data" (confirm)="confirm()" (cancel)="cancel()" class="flex--gutter-container">
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'year' | translate }}</mat-label>
      <input type="number" matInput placeholder="{{ 'year' | translate }}" formControlName="calendarYear" data-test="edit-year-name" />
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'crop' | translate }} </mat-label>
      <input
        type="text"
        [placeholder]="'crop' | translate"
        matInput
        formControlName="cropId"
        [matAutocomplete]="cropAutocomplete"
        data-test="edit-cropfield-crop"
      />
      <mat-autocomplete #cropAutocomplete="matAutocomplete" [displayWith]="displayCrop()">
        @for (option of filteredCrops$ | async; track option) {
          <mat-option [value]="option.id" data-test="edit-cropfield-crop-option">
            {{ option.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'cropVariety' | translate }} </mat-label>
      <input
        type="text"
        [placeholder]="'cropVariety' | translate"
        matInput
        formControlName="cropVarietyId"
        [matAutocomplete]="cropVarietyAutocomplete"
        data-test="edit-cropfield-crop-variety"
      />
      <mat-autocomplete #cropVarietyAutocomplete="matAutocomplete" [displayWith]="displayCropVariety()">
        @for (option of filteredCropVarieties$ | async; track option) {
          <mat-option [value]="option.id" data-test="edit-cropfield-crop-variety-option">
            {{ option.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div class="flex--row flex--gutter">
    <div>
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'cropVarietySpecificNorm' | translate }}</mat-label>
        <mat-select
          formControlName="cropVarietySpecificNorm"
          placeholder="{{ 'cropVarietySpecificNorm' | translate }}"
          data-test="edit-cropVarietySpecificNorm-name"
        >
          <mat-option [value]="null">{{ 'option_none' | translate }}</mat-option>
          @for (cropVarietySpecificNormValue of cropVarietySpecificNormValues | keyvalue; track cropVarietySpecificNormValue) {
            <mat-option [value]="cropVarietySpecificNormValue.key">{{ getCropVarietySpecificNormString(cropVarietySpecificNormValue.key) }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="mat-slide-group-wrapper">
    <div class="mat-slide-group">
      <mat-slide-toggle color="primary" formControlName="isNitrogenDifferentiation" data-test="edit-isNitrogenDifferentiation-name">{{
        'isNitrogenDifferentiation' | translate
      }}</mat-slide-toggle>
    </div>
  </div>
</agr-form-dialog>
